import { useState } from 'react';
import { toast } from 'react-toastify';
import { payWithInfluencerRazorpay } from '../providers/razorpay.provider';
import { useInfluencerCheckout, SUBSCRIPTION_STATUS } from '../context/InfluencerCheckoutContext';

function validateBilling(formData) {
  const errors = {};
  if (!formData.name?.trim()) errors.name = 'Name is required';
  const email = formData.email?.trim() || '';
  if (!email) errors.email = 'Email is required';
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.email = 'Invalid email';
  const mobile = (formData.mobile || '').trim();
  if (!/^[0-9]{10}$/.test(mobile)) errors.mobile = 'Mobile must be 10 digits';
  return errors;
}

const InfluencerPaymentButton = ({ plan, formData, setErrors }) => {
  const [loading, setLoading] = useState(false);
  const { setSubscriptionStatus } = useInfluencerCheckout();

  const handlePay = () => {
    const errors = validateBilling(formData);
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    setLoading(true);

    payWithInfluencerRazorpay({
      planType: plan.planType || 'premium',
      billingCycle: plan.billingCycle || 'monthly',
      planName: plan.name,
      billing: formData,
      onSuccess: () => {
        setLoading(false);
        setSubscriptionStatus(SUBSCRIPTION_STATUS.PROCESSING);
      },
      onError: (error) => {
        setLoading(false);
        toast.error(error?.message || 'Payment failed. Please try again.');
      },
    });
  };

  return (
    <button
      type="button"
      onClick={handlePay}
      disabled={loading}
      className="w-full bg-black text-white py-3 rounded-lg font-semibold disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-800 transition"
    >
      {loading ? 'Opening secure payment...' : `Pay ${plan.currencySymbol || '₹'}${plan.price}/mo`}
    </button>
  );
};

export default InfluencerPaymentButton;
